// components/ModalConfirm.jsx
import React, { useEffect } from 'react';
import { X, AlertTriangle } from 'lucide-react';

const ModalConfirm = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Sí, eliminar',
  cancelText = 'Cancelar',
  confirmButtonColor = '#dc2626',
  icon = 'warning',
}) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      document.body.style.overflowY = 'auto';
    }
    return () => {
      document.body.style.overflow = '';
      document.body.style.overflowY = 'auto';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="absolute inset-0 bg-black/50" />
      
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden border-2 border-[#e83e8c] animate-[swalRosaIn_0.4s_ease]">
        <div className="p-6">
          {/* Icono */}
          <div className="flex justify-center mb-4">
            <div className="w-14 h-14 rounded-full bg-red-100 flex items-center justify-center">
              <AlertTriangle className="w-7 h-7 text-red-600" />
            </div>
          </div>

          {/* Título */}
          <h3 className="text-xl font-bold text-center text-gray-800 mb-2">
            {title}
          </h3>

          {/* ✅ Mensaje con HTML renderizado */}
          <div className="text-center text-gray-600 text-sm mb-6 [&_strong]:font-semibold [&_strong]:text-gray-800">
            <div dangerouslySetInnerHTML={{ __html: message }} />
          </div>

          {/* Botones */}
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 border-2 border-gray-200 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium"
            >
              {cancelText}
            </button>
            <button
              onClick={onConfirm}
              className="flex-1 px-4 py-2 text-white rounded-lg font-medium transition-all hover:shadow-lg"
              style={{ backgroundColor: confirmButtonColor }}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirm;